<script>
  import { onMount } from "svelte";
  import { getLocal } from "./stores/store";
  import Wallpaper from "./components/Wallpaper.svelte";
  import Greeting from "./components/Greeting.svelte";
  import Clock from "./components/Clock.svelte";
  import BottomLinks from "./components/BottomLinks.svelte";

  let greeting = "Hello";

  onMount(() => {
    greeting = JSON.parse(localStorage.getItem("greeting"));
  });
</script>

<style>
  main {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    color: white;
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-rows: 100px 1fr;
    justify-content: center;
  }

  .tc {
    justify-self: center;
    display: grid;
    justify-content: center;
  }

  .bc {
    display: grid;
    justify-content: center;
    align-items: flex-end;
  }
</style>

<svelte:head>
  <title>Töövoo ~ {greeting}</title>
</svelte:head>

<Wallpaper />

<main>
  <div class="tc">
    <Greeting />
    <Clock />
  </div>
  <div class="bc">
    <BottomLinks />
  </div>
</main>
